/**
 * Given an array, remove all of it's duplicate values without changing the original
 * @param { Array } array Original array
 * @returns { Array } array without duplicate values
 */
export default array => array.filter((item, index, array) => array.indexOf(item) === index)
